import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import RequestBlock_vue_vue_type_script_setup_true_lang_default from "./RequestBlock.vue.script.js";
/* empty css                           */
//#region src/v2/blocks/request-block/RequestBlock.vue
var RequestBlock_default = /*#__PURE__*/ _plugin_vue_export_helper_default(RequestBlock_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-f9196c85"]]);
//#endregion
export { RequestBlock_default as default };

//# sourceMappingURL=RequestBlock.vue.js.map